export enum ANNUAL_DUE_DATE_BASIS {
  STANDARD = 'STANDARD',
  FISCAL_JULY_JUNE = 'FISCAL_JULY_JUNE',
}

export class StateNexusSetting {
    business_name: string = '';
    calculate_sales_tax: boolean = false;
    created_at?: Date;
    nexus_establishment_date: string = '';
    payment_schedule: string = '';
    annual_due_date_basis?: ANNUAL_DUE_DATE_BASIS | null;
    shipping_tax_included: string = '';
    state_nexus_id?: number;
    state: string = '';
    tax_id: string = '';
    updated_at?: Date;
    user_id?: string = '';
}
